export default "__VITE_ASSET__DxtoNxVa__"